import * as React from 'react';
import { useState } from 'react';

// Utils
import { t } from '@toolkit/util/i18n';
import { isNil } from '@src/shared/src/util/general';
// Constants
// Actions
// Models
// Interfaces
// Components
import { Modal } from '@toolkit/ui';
// Styles
import '../styles/FareTermsConditionsModal.scss';
import classNames from 'classnames';

type Props = {
  fareName: string;
  fareConditions: string;
  fareCancellations: string;
  fareReissue: string;
  showLinkIcon?: boolean;
};

const FareTermsConditionsModal: React.FC<Props> = (props: Props) => {
  const [showTariffConditions, setShowTariffConditions] = useState<boolean>(false);
  const { fareName, fareConditions, fareCancellations, fareReissue, showLinkIcon } = props;

  const renderSplitList = (value: string, key: string) => {
    if (isNil(value)) return null;
    const parts = value
      .split(';')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    if (parts.length === 0) return null;
    if (parts.length === 1) return <p>{parts[0]}</p>;
    return (
      <ul className="fare-terms-conditions-modal-list">
        {parts.map((part, idx) => (
          <li key={`${key}-${idx}`}>{part}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className="fare-terms-conditions-modal">
      <button
        className={classNames('fare-terms-conditions-modal-link', { 'has--icon': showLinkIcon })}
        onClick={() => setShowTariffConditions(true)}>
        {showLinkIcon && <i className="icon-external_link" />}
        {t('tariffFareTerms.button.showTariffConditions')}
      </button>
      <Modal
        isOpen={showTariffConditions}
        onClose={() => setShowTariffConditions(false)}
        title={t('tariffFareTerms.modal.tariffConditionsTitle')}>
        <div>
          <h4>{fareName}</h4>
          {!isNil(fareConditions) && <p>{fareConditions}</p>}

          {!isNil(fareCancellations) && (
            <div className="fare-terms-conditions-modal-section">
              <h5>{t('tariffFareTerms.tooltip.title.cancellation')}</h5>
              {renderSplitList(fareCancellations, "cancellations")}
            </div>
          )}

          {!isNil(fareReissue) && (
            <div className="fare-terms-conditions-modal-section">
              <h5>{t('tariffFareTerms.tooltip.title.rebooking')}</h5>
              {renderSplitList(fareReissue, "reissue")}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default FareTermsConditionsModal;
